export default __webpack_public_path__ + "static/media/dobbi_bubles.2346732c.svg";